import React from "react";
import { CardStyled } from "../../components/Card";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { Snippet } from "./Snippet";
import {
  CustomPlaceHolder,
  SnippetTitle,
  SnippetSourceDateCol,
  LogoSourceCol,
} from "./style/styledComponents";
import { ButtonsList } from "../../components/ButtonsList";
import { useTheme, Link, Grid } from "@material-ui/core";
import { getDate } from "../../utils/date";
import Image from "material-ui-image";

export const SnippetSource = ({
  sourceID,
  source,
  url,
  title,
  snippets,
  sourceDate,
  saveSnippet,
  article,
  setIframeSource,
  setOpenSourceMordal,
  saveSnippets,
  reportPic,
}) => {
  const theme = useTheme();

  const buttonsList = article.id
    ? [
        {
          onClick: () => {
            if (source.iframeAccessible) {
              setIframeSource({ url });
              setOpenSourceMordal(true);
            }
          },
          icon: "window-maximize",
          isDisabled: !source.iframeAccessible,
        },
        {
          onClick: () => saveSnippets(snippets, source, article.id),
          icon: "bookmark-o",
        },
      ]
    : [
        {
          onClick: () => {
            if (source.iframeAccessible) {
              setIframeSource({ url });
              setOpenSourceMordal(true);
            }
          },
          icon: "window-maximize",
          isDisabled: !source.iframeAccessible,
        },
      ];

  return (
    <Droppable
      droppableId={`column-source-${sourceID}`}
      isDropDisabled
      Direction="horizontal"
    >
      {(provided, snapshot) => (
        <CardStyled
          {...provided.droppableProps}
          ref={provided.innerRef}
          theme={theme}
        >
          <Grid container>
            <Grid
              item
              lg={2}
              md={4}
              xs={12}
              style={{ textAlign: "center", marginTop: "5px" }}
            >
              <Image
                src={reportPic}
                alt="thambnail"
                style={{ paddingTop: 0, position: "unset" }}
                imageStyle={{
                  height: "unset",
                  width: "unset",
                  maxHeight: "100px",
                  maxWidth: "100px",
                  borderRadius: "6px",
                  margin: "10px",
                  position: "unset",
                }}
                disableSpinner
              />
            </Grid>
            <Grid item lg={10} md={8} xs={12}>
              <Grid container alignItems="center">
                <Grid item lg={10} md={10}>
                  <SnippetTitle theme={theme}>
                    <Link
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="inherit"
                    >
                      {title}
                    </Link>
                  </SnippetTitle>
                </Grid>
                <Grid item lg={2} md={2}>
                  <SnippetSourceDateCol item theme={theme}>
                    {getDate(sourceDate)}
                  </SnippetSourceDateCol>
                </Grid>
              </Grid>

              <SnippetTitle theme={theme}>
                <Link
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  {source.name}
                </Link>
              </SnippetTitle>
              {snippets &&
                !!snippets.length &&
                snippets.map((snippet, index) => (
                  <div key={index}>
                    <Draggable
                      draggableId={`draggable-${sourceID}-${index}`}
                      index={index}
                      isDragDisabled={article.snippets.some(
                        (articleSnippet) => articleSnippet.text === snippet.text
                      )}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onDragStart={() => {}}
                        >
                          <Snippet
                            snippet={snippet}
                            source={{ ...source, url }}
                            handleSave={saveSnippet}
                            article={article}
                            isDragging={snapshot.isDragging}
                          />
                        </div>
                      )}
                    </Draggable>
                    {/* Placeholder dashed box */}
                    {snapshot.isUsingPlaceholder &&
                      (snapshot.draggingOverWith ===
                        `draggable-${sourceID}-${index}` ||
                        snapshot.draggingFromThisWith ===
                          `draggable-${sourceID}-${index}`) && (
                        <CustomPlaceHolder theme={theme} />
                      )}
                  </div>
                ))}
              {provided.placeholder}
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <LogoSourceCol item lg={2} md={2}>
              {/* <img src={source.logo} alt="logo" width={100} /> */}
            </LogoSourceCol>
            <Grid item lg={10} md={10}>
              <ButtonsList buttons={buttonsList} />
            </Grid>
          </Grid>
        </CardStyled>
      )}
    </Droppable>
  );
};
